console.log('DEBUG: main.js loaded');

/* Mobile menu burger toggle */
(function () {
    console.log('DEBUG: Mobile menu burger toggle');
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();


/* Video hover effect for card images */
(function () {
    const cardLinks = document.querySelectorAll('.gh-card-link');

    cardLinks.forEach(function (cardLink) {
        const video = cardLink.querySelector('.gh-card-video');
        if (!video) return;

        video.muted = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');

        const videoSrc = video.getAttribute('data-video-src');
        if (!videoSrc) return;

        const imageUrl = new URL(videoSrc);
        const pathParts = imageUrl.pathname.split('.');
        pathParts.pop();
        const basePath = pathParts.join('.');
        const videoPath = basePath.replace('/content/images/', '/content/media/') + '.mp4';
        const videoUrl = imageUrl.origin + videoPath;

        let isVideoLoaded = false;
        let isHovering = false;
        let isVideoLoading = false;

        // Preload video as soon as possible
        function preloadVideo() {
            if (isVideoLoaded || isVideoLoading) return;
            if (video.querySelector('source')) return;

            isVideoLoading = true;
            video.style.opacity = '0';

            const source = document.createElement('source');
            source.src = videoUrl;
            source.type = 'video/mp4';
            video.appendChild(source);
            video.load();

            video.addEventListener('loadeddata', function () {
                isVideoLoaded = true;
                isVideoLoading = false;
                if (isHovering) {
                    video.style.opacity = '1';
                    video.play().catch(function (error) {
                        console.log('Video autoplay failed:', error);
                    });
                }
            });

            video.addEventListener('error', function (e) {
                video.style.display = 'none';
                isVideoLoading = false;
                console.log('Video error:', e);
            });
        }

        // Start preloading immediately
        preloadVideo();

        cardLink.addEventListener('mouseenter', function () {
            isHovering = true;
            if (isVideoLoaded) {
                video.style.opacity = '1';
                video.play().catch(function (error) {
                    console.log('Video play failed:', error);
                });
            }
        });

        cardLink.addEventListener('mouseleave', function () {
            isHovering = false;
            video.style.opacity = '0';
            video.pause();
            video.currentTime = 0;
        });
    });
})();

/* Check for matching videos in post content and store for card hover */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    const postContent = document.querySelector('.gh-content');
    if (!postContent) return;

    const featureImage = document.querySelector('.gh-article-image img');
    if (!featureImage) return;

    const featureImageSrc = featureImage.src;
    const imageUrl = new URL(featureImageSrc);
    const pathParts = imageUrl.pathname.split('.');
    pathParts.pop();
    const baseName = pathParts.join('.').split('/').pop();

    // Remove/hide video in content if it matches the featured image base name
    const videoElements = postContent.querySelectorAll('video, .kg-video-card video, iframe[src*=".mp4"]');
    videoElements.forEach(function (videoElement) {
        let videoSrc = '';
        if (videoElement.tagName === 'VIDEO') {
            const source = videoElement.querySelector('source');
            if (source) {
                videoSrc = source.src;
            } else {
                videoSrc = videoElement.src;
            }
        } else if (videoElement.tagName === 'IFRAME') {
            videoSrc = videoElement.src;
        }
        if (videoSrc) {
            const videoUrl = new URL(videoSrc);
            const videoFileName = videoUrl.pathname.split('/').pop();
            if (videoFileName && videoFileName.replace('.mp4', '') === baseName) {
                const parentCard = videoElement.closest('.kg-video-card');
                if (parentCard) {
                    parentCard.style.display = 'none';
                } else {
                    videoElement.style.display = 'none';
                }
            }
        }
    });
})();

document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('post-template')) return;

    const postContent = document.querySelector('.gh-content');
    if (!postContent) return;

    const featureImage = document.querySelector('.gh-article-image img');
    if (!featureImage) return;

    const featureImageSrc = featureImage.src;
    const imageUrl = new URL(featureImageSrc);
    const pathParts = imageUrl.pathname.split('.');
    pathParts.pop();
    const baseName = pathParts.join('.').split('/').pop();

    // Remove/hide video in content if it matches the featured image base name
    const videoElements = postContent.querySelectorAll('video, .kg-video-card video, iframe[src*=".mp4"]');
    videoElements.forEach(function (videoElement) {
        let videoSrc = '';
        if (videoElement.tagName === 'VIDEO') {
            const source = videoElement.querySelector('source');
            if (source) {
                videoSrc = source.src;
            } else {
                videoSrc = videoElement.src;
            }
        } else if (videoElement.tagName === 'IFRAME') {
            videoSrc = videoElement.src;
        }
        if (videoSrc) {
            const videoUrl = new URL(videoSrc);
            const videoFileName = videoUrl.pathname.split('/').pop();
            if (videoFileName && videoFileName.replace('.mp4', '') === baseName) {
                const parentCard = videoElement.closest('.kg-video-card');
                if (parentCard) {
                    parentCard.style.display = 'none';
                } else {
                    videoElement.style.display = 'none';
                }
            }
        }
    });
});

/* Custom author functionality for post pages */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    const postContent = document.querySelector('.gh-content');
    if (!postContent) return;

    const authorNameElement = document.querySelector('.gh-article-author-name');
    if (!authorNameElement) return;

    const contentText = postContent.textContent;
    const customAuthorMatch = contentText.match(/custom_author:\s*"([^"]+)"/);
    const customAuthorLinkMatch = contentText.match(/custom_author_link:\s*"([^"]+)"/);

    if (customAuthorMatch) {
        const customAuthorName = customAuthorMatch[1];

        // Replace the author name in the header
        authorNameElement.textContent = customAuthorName;

        // Add link functionality if custom_author_link is provided
        if (customAuthorLinkMatch) {
            const customAuthorLink = customAuthorLinkMatch[1];

            // Create a link wrapper around the author name
            const authorLink = document.createElement('a');
            authorLink.href = customAuthorLink;
            authorLink.target = '_blank';
            authorLink.rel = 'noopener';
            authorLink.textContent = customAuthorName;

            // Replace the text content with the link
            authorNameElement.textContent = '';
            authorNameElement.appendChild(authorLink);

            // Also make the author profile images clickable with the same link
            const authorImages = document.querySelectorAll('.gh-article-author-image a');
            authorImages.forEach(function (authorImageLink) {
                authorImageLink.href = customAuthorLink;
                authorImageLink.target = '_blank';
                authorImageLink.rel = 'noopener';
            });
        }

        // // Update Open Graph meta tags for social sharing
        // const ogAuthorMeta = document.querySelector('meta[property="article:author"]');
        // if (ogAuthorMeta) {
        //     ogAuthorMeta.setAttribute('content', customAuthorName);
        // }

        // // Update page title to include custom author
        // const pageTitle = document.querySelector('title');
        // if (pageTitle) {
        //     const currentTitle = pageTitle.textContent;
        //     const originalAuthor = contentText.match(/custom_author:\s*"([^"]+)"/);
        //     if (originalAuthor) {
        //         const newTitle = currentTitle.replace(/by\s+[^|]+/i, `by ${customAuthorName}`);
        //         pageTitle.textContent = newTitle;
        //     }
        // }

        // // Update structured data
        // const structuredData = document.querySelector('script[type="application/ld+json"]');
        // if (structuredData) {
        //     try {
        //         const data = JSON.parse(structuredData.textContent);
        //         if (data.author && data.author.name) {
        //             data.author.name = customAuthorName;
        //             structuredData.textContent = JSON.stringify(data, null, 2);
        //         }
        //     } catch (e) {
        //         console.log('Error updating structured data:', e);
        //     }
        // }

        // Remove the custom_author and custom_author_link lines from the content
        const paragraphs = postContent.querySelectorAll('p');
        paragraphs.forEach(function (paragraph) {
            const paragraphText = paragraph.textContent.trim();
            if (paragraphText.includes('custom_author:') || paragraphText.includes('custom_author_link:')) {
                paragraph.style.display = 'none';
            }
        });
    }
})();

/* Custom author functionality for post cards */
(function () {
    const postCards = document.querySelectorAll('.gh-card');

    postCards.forEach(function (card) {
        const cardText = card.textContent;
        const customAuthorMatch = cardText.match(/custom_author:\s*"([^"]+)"/);
        const customAuthorLinkMatch = cardText.match(/custom_author_link:\s*"([^"]+)"/);

        if (customAuthorMatch) {
            const customAuthorName = customAuthorMatch[1];

            // Replace the author name in the card
            const cardAuthorElement = card.querySelector('.gh-card-author');
            if (cardAuthorElement) {
                cardAuthorElement.textContent = 'By ' + customAuthorName;

                // Add link functionality if custom_author_link is provided
                if (customAuthorLinkMatch) {
                    const customAuthorLink = customAuthorLinkMatch[1];

                    // Create a link wrapper around the author name
                    const authorLink = document.createElement('a');
                    authorLink.href = customAuthorLink;
                    authorLink.target = '_blank';
                    authorLink.rel = 'noopener';
                    authorLink.textContent = customAuthorName;

                    // Replace the text content with the link
                    cardAuthorElement.textContent = 'By ';
                    cardAuthorElement.appendChild(authorLink);
                }
            }

            // Remove only the custom_author and custom_author_link text from the card content
            const allElements = card.querySelectorAll('*');
            allElements.forEach(function (element) {
                if (element.children.length === 0) {
                    const elementText = element.textContent;
                    if (elementText.includes('custom_author:') || elementText.includes('custom_author_link:')) {
                        const cleanText = elementText
                            .replace(/custom_author:\s*"[^"]*"/g, '')
                            .replace(/custom_author_link:\s*"[^"]*"/g, '')
                            .replace(/\s+/g, ' ')
                            .trim();
                        element.textContent = cleanText;
                    }
                }
            });
        }
    });
})();

// Custom Sign-up Modal Functionality
document.addEventListener('DOMContentLoaded', function () {
    const customSignupModal = document.querySelector('.custom-signup-modal');
    const customSignupForm = document.querySelector('.custom-signup-form');

    // Open modal when clicking on any sign-up buttons or links
    document.addEventListener('click', function (e) {
        if (e.target.matches('[data-custom-signup]') ||
            e.target.matches('[data-portal="signup"]') ||
            e.target.matches('a[href="#/portal/signup"]') ||
            e.target.matches('a[href="#/portal/"]') ||
            e.target.closest('[data-portal="signup"]') ||
            e.target.closest('a[href="#/portal/signup"]') ||
            e.target.closest('a[href="#/portal/"]') ||
            e.target.closest('[data-custom-signup]')) {
            e.preventDefault();
            openCustomSignupModal();
        }
    });

    // Open modal when clicking on any sign-in buttons or links
    document.addEventListener('click', function (e) {
        if (e.target.matches('[data-custom-signin]') ||
            e.target.matches('[data-portal="signin"]') ||
            e.target.matches('a[href="#/portal/signin"]') ||
            e.target.closest('[data-portal="signin"]') ||
            e.target.closest('a[href="#/portal/signin"]') ||
            e.target.closest('[data-custom-signin]')) {
            e.preventDefault();
            openCustomSigninModal();
        }
    });

    // Close modal when clicking outside or on close button
    if (customSignupModal) {
        customSignupModal.addEventListener('click', function (e) {
            if (e.target === customSignupModal) {
                closeCustomSignupModal();
            }
        });

        const closeButton = customSignupModal.querySelector('.custom-signup-close');
        if (closeButton) {
            closeButton.addEventListener('click', closeCustomSignupModal);
        }
    }

    // Custom Sign-in Modal Functionality
    const customSigninModal = document.querySelector('.custom-signin-modal');
    const customSigninForm = document.querySelector('.custom-signin-form');

    // Close sign-in modal when clicking outside or on close button
    if (customSigninModal) {
        customSigninModal.addEventListener('click', function (e) {
            if (e.target === customSigninModal) {
                closeCustomSigninModal();
            }
        });

        const closeButton = customSigninModal.querySelector('.custom-signin-close');
        if (closeButton) {
            closeButton.addEventListener('click', closeCustomSigninModal);
        }
    }

    // Handle form submission
    if (customSignupForm) {
        customSignupForm.addEventListener('submit', function (e) {
            e.preventDefault();
            handleCustomSignupSubmit();
        });
    }

    // Handle sign-in form submission
    if (customSigninForm) {
        customSigninForm.addEventListener('submit', function (e) {
            e.preventDefault();
            handleCustomSigninSubmit();
        });
    }

    // Handle sign-in link clicks
    document.addEventListener('click', function (e) {
        if (e.target.matches('.custom-signup-login-link')) {
            e.preventDefault();
            closeCustomSignupModal();
            openCustomSigninModal();
        }
    });

    // Handle sign-up link clicks
    document.addEventListener('click', function (e) {
        if (e.target.matches('.custom-signin-signup-link')) {
            e.preventDefault();
            closeCustomSigninModal();
            openCustomSignupModal();
        }
    });

    // Handle hash changes for portal routes
    window.addEventListener('hashchange', function () {
        const hash = window.location.hash;
        if (hash === '#/portal/' || hash === '#/portal/signup') {
            // Prevent default Ghost portal behavior
            history.replaceState(null, null, window.location.pathname);
            openCustomSignupModal();
        } else if (hash === '#/portal/signin') {
            // Prevent default Ghost portal behavior
            history.replaceState(null, null, window.location.pathname);
            openCustomSigninModal();
        }
    });

    // Check initial hash on page load
    if (window.location.hash === '#/portal/' || window.location.hash === '#/portal/signup') {
        // Prevent default Ghost portal behavior
        history.replaceState(null, null, window.location.pathname);
        openCustomSignupModal();
    } else if (window.location.hash === '#/portal/signin') {
        // Prevent default Ghost portal behavior
        history.replaceState(null, null, window.location.pathname);
        openCustomSigninModal();
    }
});

function openCustomSignupModal() {
    const modal = document.querySelector('.custom-signup-modal');
    if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Focus on first input
        const firstInput = modal.querySelector('.custom-signup-input');
        if (firstInput) {
            setTimeout(() => firstInput.focus(), 300);
        }
    }
}

function closeCustomSignupModal() {
    const modal = document.querySelector('.custom-signup-modal');
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';

        // Reset form
        const form = modal.querySelector('.custom-signup-form');
        if (form) {
            form.reset();
            form.classList.remove('loading', 'success', 'error');
        }
    }
}

function handleCustomSignupSubmit() {
    const form = document.querySelector('.custom-signup-form');
    const emailInput = form.querySelector('[data-members-email]');
    const nameInput = form.querySelector('[data-members-name]');

    // Basic validation
    if (!emailInput.value || !emailInput.checkValidity()) {
        showFormError('Please enter a valid email address.');
        return;
    }

    // Show loading state
    form.classList.remove('success', 'error');
    form.classList.add('loading');

    // Simulate form submission (Ghost will handle the actual submission)
    // The form will be processed by Ghost's built-in functionality
    setTimeout(() => {
        form.classList.remove('loading');
        form.classList.add('success');

        // Close modal after success
        setTimeout(() => {
            closeCustomSignupModal();
        }, 2000);
    }, 1500);
}

function showFormError(message) {
    const form = document.querySelector('.custom-signup-form');
    form.classList.remove('loading', 'success');
    form.classList.add('error');

    // Reset error state after 3 seconds
    setTimeout(() => {
        form.classList.remove('error');
    }, 3000);
}

function openCustomSigninModal() {
    const modal = document.querySelector('.custom-signin-modal');
    if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Focus on first input
        const firstInput = modal.querySelector('.custom-signin-input');
        if (firstInput) {
            setTimeout(() => firstInput.focus(), 300);
        }
    }
}

function closeCustomSigninModal() {
    const modal = document.querySelector('.custom-signin-modal');
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';

        // Reset form
        const form = modal.querySelector('.custom-signin-form');
        if (form) {
            form.reset();
            form.classList.remove('loading', 'success', 'error');
        }
    }
}

function handleCustomSigninSubmit() {
    const form = document.querySelector('.custom-signin-form');
    const emailInput = form.querySelector('[data-members-email]');

    // Basic validation
    if (!emailInput.value || !emailInput.checkValidity()) {
        showSigninFormError('Please enter a valid email address.');
        return;
    }

    // Show loading state
    form.classList.remove('success', 'error');
    form.classList.add('loading');

    // Simulate form submission (Ghost will handle the actual submission)
    // The form will be processed by Ghost's built-in functionality
    setTimeout(() => {
        form.classList.remove('loading');
        form.classList.add('success');

        // Close modal after success
        setTimeout(() => {
            closeCustomSigninModal();
        }, 2000);
    }, 1500);
}

function showSigninFormError(message) {
    const form = document.querySelector('.custom-signin-form');
    form.classList.remove('loading', 'success');
    form.classList.add('error');

    // Reset error state after 3 seconds
    setTimeout(() => {
        form.classList.remove('error');
    }, 3000);
}
